import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyAgentPromoteSectionComponent } from '../../../sections/property-default-sections/property-agent-promote-section/property-agent-promote-section.component';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';

@Component({
    selector: 'property-agent-promote-page',
    templateUrl: './property-agent-promote-page.component.html',
    styleUrls: ['./property-agent-promote-page.component.scss'],
    standalone: false
})
export class PropertyAgentPromotePageComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(PropertyAgentPromoteSectionComponent, {
        read: PropertyAgentPromoteSectionComponent
    })
    propertyAgentPromoteSectionComponent: PropertyAgentPromoteSectionComponent;

    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyPromote, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyAgentPromoteSectionComponent);
    }
}
